import React, { useState } from "react";
import { IMAGES } from "../../lib/content";
import { ytThumb, ytEmbed } from "../../lib/youtube";

const POSTERS = [IMAGES.hero, IMAGES.suite, IMAGES.jacuzzi, IMAGES.arch, IMAGES.gym, IMAGES.interior];

function LockedPoster({ ep, index, t }) {
  return (
    <div className="absolute inset-0 scanlines" data-testid={`episode-locked-${index}`}>
      <img
        src={POSTERS[index % POSTERS.length]}
        alt=""
        className="w-full h-full object-cover opacity-30 grayscale blur-[2px] scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0C] via-[#0B0B0C]/40 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-10 ep-locked-stripes opacity-60" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <div className="mono text-[10px] uppercase tracking-[0.32em] text-[#F1EDE6]/60">
          {t.ep_label} {ep.number}
        </div>
        <div className="mt-2 condensed text-[64px] md:text-[88px] text-[#F1EDE6] flicker tracking-[0.06em]">
          {t.coming_soon_label}
        </div>
        <div className="mt-2 mono text-[9px] uppercase tracking-[0.28em] text-[color:var(--alta-red-soft)]">
          {t.coming_soon_hint}
        </div>
      </div>
      <div className="frame-mark tl" /><div className="frame-mark tr" />
      <div className="frame-mark bl" /><div className="frame-mark br" />
    </div>
  );
}

function Player({ ep, index, t }) {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <iframe
        data-testid={`episode-iframe-${index}`}
        className="absolute inset-0 w-full h-full"
        src={ytEmbed(ep.youtube_id)}
        title={ep.title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    );
  }
  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      data-testid={`episode-play-${index}`}
      className="absolute inset-0 w-full h-full group/play text-left"
      aria-label={`${t.watch_label} — ${ep.title}`}
    >
      <img
        src={ytThumb(ep.youtube_id)}
        alt={ep.title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover/play:scale-105"
      />
      <div className="absolute inset-0 bg-[#0B0B0C]/30 group-hover/play:bg-[#0B0B0C]/10 transition-colors" />
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="w-20 h-20 rounded-full border border-[#F1EDE6]/60 bg-[#0B0B0C]/50 backdrop-blur flex items-center justify-center group-hover/play:bg-[color:var(--alta-red)] group-hover/play:border-[color:var(--alta-red)] transition-colors">
          <span className="ml-1 border-y-[10px] border-y-transparent border-l-[16px] border-l-[#F1EDE6]" />
        </span>
      </div>
      <div className="absolute bottom-4 left-4 mono text-[9px] uppercase tracking-[0.28em] text-[#F1EDE6]/80">
        {t.watch_label}{ep.duration ? ` · ${ep.duration}` : ""}
      </div>
    </button>
  );
}

export default function EpisodeCard({ ep, index, t, featured = false }) {
  const unlocked = !!ep.youtube_id;
  return (
    <article
      data-testid={`episode-card-${index}`}
      className={`relative border border-white/10 bg-[#111113] group ${featured ? "md:col-span-2" : ""}`}
    >
      <div className="relative aspect-video overflow-hidden bg-black">
        {unlocked ? <Player ep={ep} index={index} t={t} /> : <LockedPoster ep={ep} index={index} t={t} />}
      </div>
      <div className="p-6 md:p-8 flex items-start gap-6">
        <div className="condensed text-[56px] md:text-[72px] leading-none text-[color:var(--alta-red-soft)]">{ep.number}</div>
        <div className="flex-1 min-w-0">
          <div className="mono text-[9px] uppercase tracking-[0.3em] text-[#F1EDE6]/50">
            {t.ep_label} {ep.number} · {unlocked ? (ep.duration || "Disponível") : t.coming_soon_label}
          </div>
          <h3 className="mt-2 condensed text-[32px] md:text-[40px] text-[#F1EDE6] tracking-[0.04em]" data-testid={`episode-title-${index}`}>
            {ep.title}
          </h3>
          <p className="mt-3 text-[14px] leading-[1.7] text-[#F1EDE6]/65 font-light max-w-[58ch]">{ep.desc}</p>
        </div>
      </div>
    </article>
  );
}
